import router from './router'
import ActivityLogMessages from './localization'

export default {
  router,
  localization: ActivityLogMessages,
}
